export default "__VITE_ASSET__ff18f815__"